
import React from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import Header from "./components/Header";
import AppRoutes from "./routes";
import ActivityTracker from "./components/ActivityTracker";
import AnnouncementPopup from "./components/AnnouncementPopup";
import Chatbot from "./pages/Chatbot";
import "./index.css";
import "leaflet/dist/leaflet.css";

function AppShell() {
  const location = useLocation();
  const isChatbotPage = location.pathname.startsWith("/chatbot");

  if (isChatbotPage) {
    return <Chatbot />;
  }

  const showHeader = location.pathname !== "/login";

  return (
    <div className="app-shell">
      <ActivityTracker />
      {showHeader && <Header />}
      <AnnouncementPopup />
      <div className="app-body">
        <main className="app-content">
          <AppRoutes />
        </main>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
